import { useQuery } from '@tanstack/react-query'
import { getReseller as getResellerService } from '@grupoboticario/barril-del-chavo'
import { useParams } from 'react-router-dom'
import { IReseller, IResellerModifiedUnion } from 'src/@interfaces'
import { getConfig } from 'src/helpers'
import { QUERY_DATA, queryConfig } from 'src/service'
import { useCallback } from 'react'

export type IResellerModified = Omit<IReseller, 'region' | 'photo'> & {
  region: string | null
  photo: {
    thumbnail: string
    fullSize: string
  }
}

const config = getConfig()

const queryKey = QUERY_DATA.RESELLER

export const useReseller = (resellerSlug?: string) => {
  const { reseller: catalogSlug } = useParams()

  const finalCatalogSlug = resellerSlug || catalogSlug || config.genericUser.catalogSlug

  const isGenericUser = finalCatalogSlug === config.genericUser.catalogSlug

  const getReseller = useCallback(() => {
    if (isGenericUser) {
      return Promise.resolve(config.genericUser)
    }

    return getResellerService({
      businessUnit: config.businessUnit,
      resellerSlug: finalCatalogSlug,
    })
  }, [finalCatalogSlug, isGenericUser])

  const results = useQuery<IResellerModifiedUnion>(
    [queryKey, catalogSlug],
    getReseller,
    queryConfig,
  )

  return { ...results, isGenericUser }
}
